/**
 * @fileoverview POST handler for the "/engagement/report_builder_2/:app_group_id/update_tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportBuilder2AppGroupIdUpdateTagsCacheKeys } from "./constants";
import type {
  PutEngagementReportBuilder2AppGroupIdUpdateTagsProps,
  ReportBuilder2BulkUpdateTagsResult,
} from "./types";

export const putReportBuilder2BulkUpdateTags = reactQueryMutationAdapter(
  engagementReportBuilder2AppGroupIdUpdateTagsCacheKeys,
  ({
    desired_state,
    undo_identifier,
    app_group_id,
  }: PutEngagementReportBuilder2AppGroupIdUpdateTagsProps): Promise<ReportBuilder2BulkUpdateTagsResult> => {
    return fetch(
      `/engagement/report_builder_2/${app_group_id}/update_tags`,
      "PUT",
      { desired_state, undo_identifier },
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
